import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ToggleOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"toggle_off"}/>
}
